'use strict'

export let english={
  general: {
    benefit: "Benefit",
    businessCase: "Business Case"
  },
  strategy: {
    title: "Strategy and Objectives",
    fields: {
      reasons: {
        title: "Reasons",
        help:`Which part of the business strategy is supported by the outputs of this project?
          If this project is part of a programme, which programme objectives are supported by this project’s outputs?`,
        description: "The reason for undertaking the project and how the project will enable strategies and objectives"
      }
    }
  },
  summary: {
    title: "Summary",
    fields: {
      executiveSummary: {
        title: "Excecutive Summary",
        help: `What is the main reason why a change is needed?
          What are the key outputs a project will deliver, and what are the most important benefits this will bring?
          What is the total investment cost and the high level project timeline?
          What do we know about the return of the investment?`,
        description: "Highlight of important benefits, return on investment and other keypoints"
      }
    }
  },
  options: {
    title: "Options",
    fields: {
      doNothing: {
        title: "Do nothing",
        help: `What is the current situation like?
          What are the consequences if nothing is done?
          What is the lost opportunity if nothing is done?
          Any time or money wasted with current situation?
          How can we be sure “doing nothing” is a bad option?`,
        description: "What will happen if nothing is done"
      },
      doMinimal: {
        title: "Do minimal",
        help: `What is the minimum scope that would make a difference to the current situation?
          Is there a small step that can be made first, and then more can be done later?`,
        description: "Describe the minimal business option"
      },
      doSomething: {
        title: "Do something",
        help: `Have several other options been investigated? If no – why not? If yes, what are they?
          What main benefits do each option give?
          What complexity level or investment level would be needed for each option?`,
        description: "List the options evaluated. Describe which option was selected and why"
      }
    }
  },
  benefits: {
    title: "Benefits",
    fields: {
      benefits: {
        title: "Key benefits",
        help: `Benefits are measurable results through the use of the project’s outputs. You can look at benefits as Key Performance Indicators (KPIs) to be used, also after the project is closed, to measure the progress of the business case. Can you measure improved efficiency, lower cost, better data or product quality, increased usage, better stability, better response time, better customer satisfaction, increased compliance or increased market share?`,
        columns: {
          no: {title: "Id" },
          title: {title: "Benefit" },
          baseline: {title: "Baseline" },
          goal: {title: "Goal" },
          accountable: {title: "Accountable" }
        },
        options: {
          addEntry: {
            title: "Add benefit"
          }
        }
      }
    }
  },
  returnOnInvestment: {
    title: "Return on Investment",
    fields: {
      projectPlanSummary: {
        title: "Summary of the project plan",
        help: `What is the total investment of the project?
          How long will the project last? Over which period will the benefits be realized?
          What will be the cost on ongoing operation and maintenance?`,
        description: "The total investment over which time period"
      },
      investmentAppraisal: {
        title: "Investment Appraisal",
        help: `What is the value of the benefits and how does it compare to the total investments needed?
          Where will the investment funding come from? Where will maintenance cost come from?
          Can you quantify the return on investment by describing when the investment will be paid
          back, what the net present value is, or what the internal rate of return is?`,
        description: "Compare total investment with planned benefits. Return on Investment. Net present value. etc."
      },
      risks: {
        title: "Major risks",
        help: `Are there any specific risks to the project and the business case?
          If so, what is the likely impact those risks?
          What should be done to mitigate those risks?`,
        description: "Key risk associated with the project together with the likely impact and plans should they occur."
      }
    }
  },
  benefitDetails: {
    title:"Benefit details",
    fields: {
      title: {
        title: "Benefit title",
        description: "Short descriptive name of the benefit"
      },
      accountable:{
        title: "Accountable",
        help: `Who needs to follow up and make sure this benefit is realized – also after the project is done?`,
        description: "Name of the accountable for the benefit"
      },
      measurement: {
        title: "How and when this benefit can be measured",
        help: `Is there a technique used to measure this benefit? Any tools or methods?
          When should this benefit be measured? During the project? After the project?
          Should a baseline be measured before the project is executed?`,
        description: "Describe how this benefit can be measured and when it should be measured"
      },
      actions: {
        title: "Management actions and resources",
        help: `Are there any management actions required to ensure the project’s outcomes are achieved?
          Any resources (people, money, tools etc.) needed to follow up benefit measurements and benefit realization?`,
        description: "Management actions required to realize benefits and needed resources"
      },
      baseline: {
        title: "Baseline",
        help: `What is the measurable value of this benefit before the project is executed?`,
        description: "The measurable value before the project"
      },
      goal: {
        title: "Goal",
        help: `What is the measurable end goal of this benefit linked to the business case?`,
        description: "Measurable goal"
      }
    }
  }
}



// WEBPACK FOOTER //
// ./views/businessCase/labels/english.js